export default "https://cdn-static.gokick.com/assets/30adf10d1d1967cb40501bfdbefb418f6cea25a6/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";